import template from './passwordReset.html';
import controller from './passwordReset.controller';

let passwordResetComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default passwordResetComponent;



// WEBPACK FOOTER //
// ./app/components/passwordReset/passwordReset.component.js